import styled from 'styled-components';

export const KanbanBoardContainer = styled.div`
  display: flex;
`;

export const TaskGroupContainer = styled.div`
  margin: 8px;
  border: 1px solid lightgrey;
  border-radius: 2px;
  width: 220px;

  display: flex;
  flex-direction: column;
`;

export const TaskContainer = styled.div`
  border: 1px solid lightgrey;
  border-radius: 2px;
  padding: 8px;
  margin-bottom: 8px;
  background-color: ${(props) =>
    props.isDragDisabled ? 'lightgrey' : props.isDragging ? 'lightgreen' : 'white'};
`;

export const TaskGroupTitle = styled.h3`
  padding: 8px;
`;

export const TaskList = styled.div`
  padding: 8px;
  background-color: ${(props) => (props.isDraggingOver ? '#f5f5f5' : 'white')};
  flex-grow: 1;
  min-height: 100px;
`;
